import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';
import LayoutProvider from '../../Contexts/LayoutProvider';
import PageTitle from '../../utils/PageTitle';
import { mkRelativeUrl } from '../../utils/URL';
import ApiPageProvider, { useApiPage } from './ApiPageProvider';
import ApiPageBody from './Components/ApiPageBody';
import ApiPageHeader from './Components/ApiPageHeader';
import ApiPageHeaderMobile from './Components/ApiPageHeaderMobile';

function PageComponent() {
    const { setParams, allControllerData } = useApiPage();
    const navigate = useNavigate();

    // Search Params
    const [searchParams] = useSearchParams();
    const [queryStr, setQueryStr] = useState({ q: searchParams.get('q') || '' });
    const p = useMemo(
        () => ({
            q: searchParams.get('q') || '',
            method: searchParams.get('method') || ''
        }),
        [searchParams]
    );

    const debounceUpdate = useDebouncedCallback((val) => {
        navigate(mkRelativeUrl('/api/list', { ...p, q: val }));
    }, 800);

    const handleChangeFilterData = (e) => {
        const { name, value } = e.target;
        if (name) {
            if (name === 'q') {
                setQueryStr({ q: value });
                debounceUpdate(value);
            } else {
                navigate(mkRelativeUrl('/api/list', { ...p, [name]: value }));
            }
        }
    };

    useEffect(() => {
        setParams(p);
    }, [p, setParams]);

    return (
        <div className="inner_page_cont">
            <LayoutProvider>
                <ApiPageHeader
                    layout="default"
                    handleChangeFilterData={handleChangeFilterData}
                    p={{ ...p, ...queryStr }}
                />
                <ApiPageHeaderMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    p={{ ...p, ...queryStr }}
                    onChangeHandler={handleChangeFilterData}
                    onResetFilter={() =>
                        navigate(mkRelativeUrl('/api/list', { q: '', method: '' }))
                    }
                />
            </LayoutProvider>
            <ApiPageBody data={allControllerData} />
        </div>
    );
}

function ApiPage() {
    // set page title
    PageTitle(`API`);

    return (
        <ApiPageProvider>
            <PageComponent />
        </ApiPageProvider>
    );
}

export default ApiPage;
